<template>
  <div class="skeleton-card">
    <div class="avatar shimmer"></div>

    <div class="line title shimmer"></div>
    <div class="line subtitle shimmer"></div>
    <div class="line info shimmer"></div>

    <div class="btn-row">
      <div class="btn shimmer"></div>
      <div class="btn shimmer"></div>
    </div>
  </div>
</template>

<style scoped>
.skeleton-card {
  width: 100%;
  min-height: 255px;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 22px 18px;

  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 22px;

  box-shadow:
    0 10px 30px rgba(15, 23, 42, 0.05);

  transition: .25s;
}

/* ------------------------- */
/* Colors */
/* ------------------------- */

.skeleton-card {
  --card-bg: #ffffff;
  --card-border: rgba(27, 40, 67, .08);

  --shimmer-base: #edf1f5;
  --shimmer-highlight: #ffffff;
}

[data-theme="dark"] .skeleton-card {
  --card-bg: #29292d;
  --card-border: rgba(255,255,255,.06);

  --shimmer-base: #36373d;
  --shimmer-highlight: #474950;

  box-shadow:
    0 12px 30px rgba(0,0,0,.22);
}

/* ------------------------- */
/* Avatar */
/* ------------------------- */

.avatar {
  width: 86px;
  height: 86px;

  margin-bottom: 18px;

  border-radius: 50%;
}

/* ------------------------- */
/* Text */
/* ------------------------- */

.line {
  height: 12px;

  border-radius: 999px;

  margin-bottom: 10px;
}

.title {
  width: 58%;
  height: 15px;
}

.subtitle {
  width: 78%;
}

.info {
  width: 46%;
  margin-bottom: 22px;
}

/* ------------------------- */
/* Buttons */
/* ------------------------- */

.btn-row {
  display: flex;
  gap: 12px;

  margin-top: auto;
}

.btn {
  width: 42px;
  height: 42px;

  border-radius: 50%;
}

/* ------------------------- */
/* Shimmer */
/* ------------------------- */

.shimmer {
  position: relative;

  overflow: hidden;

  background: var(--shimmer-base);
}

.shimmer::after {
  content: "";

  position: absolute;
  inset: 0;

  transform: translateX(-100%);

  background:
    linear-gradient(
      90deg,
      transparent 0%,
      rgba(255,255,255,.08) 30%,
      rgba(255,255,255,.65) 50%,
      rgba(255,255,255,.08) 70%,
      transparent 100%
    );

  animation: shimmer 1.4s ease-in-out infinite;
}

[data-theme="dark"] .shimmer::after {
  background:
    linear-gradient(
      90deg,
      transparent 0%,
      rgba(255,255,255,.03) 30%,
      rgba(255,255,255,.12) 50%,
      rgba(255,255,255,.03) 70%,
      transparent 100%
    );
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>